/**
 * The closing call to action shared by the ISO Lead Auditor listing and every
 * per-service page under it. One copy, so the section cannot drift between
 * pages — the copy itself is unchanged from what the listing already showed.
 */
export const trainingCtaContent = {
  title: "Become a Certified ISO Lead Auditor",
  paragraph:
    "Gain global recognition, auditing competence, and professional credibility through structured ISO Lead Auditor certification programs.",
  cta: { label: "Enroll Now", to: "/contact" },
  image: "/assets/cta/certification-journey.webp",
};

export default trainingCtaContent;
